var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.993,
    cy: 26.99,
    r: 26.317,
    fill: "#F59582"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F59582",
    d: "M13.492 13.49h27v27h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.755 28.1h13.548l-4.706 4.705a1.223 1.223 0 0 0 0 1.723 1.208 1.208 0 0 0 1.71 0l6.78-6.78a1.208 1.208 0 0 0 0-1.71l-6.768-6.793a1.208 1.208 0 0 0-1.71 0 1.208 1.208 0 0 0 0 1.71l4.694 4.719H18.755c-.667 0-1.213.545-1.213 1.212 0 .668.546 1.213 1.213 1.213Z",
    fill: "#362B24"
  }))));
};
export default SvgArrow;